module.exports = __webpack_public_path__ + "img/mr_logo.8f9b9704.png";